import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FragmentsModule } from './fragments/fragments.module';
import Intercom from '@intercom/messenger-js-sdk';
import { AuthService } from '../../shared/services/auth.service';
import { AdminModule } from '../../admin/admin.module';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, FragmentsModule, AdminModule],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.css'
})
export class AdminLayoutComponent {

  constructor(
    private _AuthService: AuthService
  ) {
  }

  ngOnInit() {

    const user = this._AuthService.profile();
    Intercom({
      app_id: 'ltkh63p1',
      user_id: user._id,
      name: user.firstname ?? user.username,
      email: user.username,
      created_at: user.createdAt,
    });
  }
}
